import React from "react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";

interface TabDefinition {
    value: string;
    label: React.ReactNode;
}

interface TabLayoutProps {
    tabs: TabDefinition[];
    defaultValue?: string;
    className?: string;
    children: React.ReactNode[];
}

export function TabLayout({ tabs, defaultValue, className, children }: TabLayoutProps) {
    return (
        <Tabs defaultValue={defaultValue || tabs[0]?.value} className={className}>
            <TabsList className={`w-fit flex`}>
                {tabs.map((tab) => (
                    <TabsTrigger key={tab.value} value={tab.value}>
                        {tab.label}
                    </TabsTrigger>
                ))}
            </TabsList>
            {tabs.map((tab, idx) => (
                <TabsContent key={tab.value} value={tab.value}>
                    {Array.isArray(children) ? children[idx] : children}
                </TabsContent>
            ))}
        </Tabs>
    );
}

// Usage Example (remove or comment out in production):
/*
<TabLayout
  tabs={[
    { value: "account", label: "Account" },
    { value: "password", label: "Password" },
  ]}
>
  <div>Account content here</div>
  <div>Password content here</div>
</TabLayout>
*/
